<template>
  <div class="container">
    <div class="page-content">

      <div class="page-content--wrap">

        <div class="page-content--body ">
          <div class="page-content--body-right">
            <div class="block-wrap pb-8">
              <div class="card-title d-flex justify-space-between align-center pb-2">
                О мастере
                <v-btn class="btn-blue with-icon" color="primary">
                  <span>Редактировать</span>
                </v-btn>
              </div>
              <p>Идейные соображения высшего порядка, а также перспективное планирование не даёт нам иного выбора, кроме определения экономической целесообразности принимаемых решений. Для современного мира глубокий уровень погружения обеспечивает широкому кругу (специалистов) участие в формировании экспериментов, поражающих по своей масштабности и грандиозности.</p>
              <p>Идейные соображения высшего порядка, а также постоянный количественный рост и сфера нашей активности не даёт нам иного выбора, кроме определения новых предложений. Не следует, однако, забывать, что курс на социально-ориентированный национальный проект однозначно фиксирует необходимость укрепления моральных ценностей.</p>
            </div>
            <div class="block-wrap pb-8">
              <div class="card-title">
                Специализации
              </div>
              <ul class="check-list">
                <li class="checked">Водяной теплый пол</li>
                <li class="color-grey">Канализация</li>
                <li class="checked">Водоснабжение</li>
                <li class="color-grey">Автоматика</li>
                <li class="color-grey">Обвязка котельной</li>
              </ul>
            </div>
            <div class="block-wrap pb-8">
              <div class="card-title d-flex justify-space-between align-center pb-2">
                Работы
                <v-btn class="btn-blue with-icon" color="primary">
                  <span>Добавить работу</span>
                </v-btn>
              </div>

              <div class="portfolio">
                <div class="portfolio--cards">

                  <div class="portfolio--cards-point">
                    <div class="portfolio--cards-point-img">
                      <img src="../../../assets/images/portfolio-img01.jpg" alt="">
                    </div>
                    <div class="portfolio--cards-point-title">Монтаж очень сложной штуки</div>
                    <div class="portfolio--cards-point-location">
                      <img src="@/assets/images/ico-location.svg" alt="">
                      <span>Москва</span>
                    </div>
                    <v-dialog
                      v-model="dialog2"
                      max-width="800px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="portfolio--cards-point-more"
                        >
                          Подробнее
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title class="card-title">
                          Добавление / изменение работы
                        </v-card-title>
                        <v-card-text>
                          <v-form
                            autocomplete="off"
                            lazy-validation
                            ref="form"
                            class="auth-form"
                          >
                            <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Название</div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  required
                                  disabled
                                ></v-text-field>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Город </div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Тип</div>
                                <v-select
                                  :items="['Нормальный тип', 'Мутный тип', 'Чёткий тип', 'Не тип']"
                                  outlined
                                  dense
                                  required
                                ></v-select>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Адрес</div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </div>
                            </div>

                            <div class="add-files">
                              <div class="input-label">Добавление файлов</div>
                              <div class="add-files--button">
                                <v-btn
                                  type="submit"
                                  color="primary"
                                  class="btn-blue mb-0 btn-small"
                                >
                                  <v-icon class="mr-2">mdi-account-circle-outline</v-icon>
                                  Добавить
                                </v-btn>
                                <div class="add-files--button-text">Минимум 4, максимум 15 изображений. Формат – JPG, PNG, TIFF или BMP. Размер – не более 5 МБ. Рекомендуемое разрешение – не менее 720 x 720 пикс. и не более 3000 x 3000 пикс.</div>
                              </div>
                              <div class="add-files--list">
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                              </div>
                            </div>

                            <div class="auth-form--wrap">
                              <div class="input-label">Описание</div>
                              <v-textarea
                                filled
                                outlined
                                dense
                              ></v-textarea>
                            </div>
                            <div class="auth-form--wrap with-chbox">
                              <div class="card-checkbox">
                                <v-checkbox v-model="checkbox" hide-details>
                                  <template v-slot:label>
                                    <div class="input-label">
                                      <span class="font-weight-black">Публичная работа</span>
                                      <span class="color-grey">Данная работа будет доступна для просмотра заказчикам</span>
                                    </div>
                                  </template>
                                </v-checkbox>
                              </div>
                              <v-btn
                                type="submit"
                                color="primary"
                                class="btn-blue mb-0"
                              >
                                Сохранить / Опубликовать
                              </v-btn>
                            </div>
                          </v-form>


                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </div>

                  <div class="portfolio--cards-point">
                    <div class="portfolio--cards-point-img">
                      <img src="../../../assets/images/portfolio-img02.jpg" alt="">
                    </div>
                    <div class="portfolio--cards-point-title">Монтаж очень очень очень очень сложной штуки</div>
                    <div class="portfolio--cards-point-location">
                      <img src="@/assets/images/ico-location.svg" alt="">
                      <span>Санкт-Петербург</span>
                    </div>
                    <v-dialog
                      v-model="dialog3"
                      max-width="800px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="portfolio--cards-point-more"
                        >
                          Подробнее
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title class="card-title">
                          Добавление / изменение работы
                        </v-card-title>
                        <v-card-text>
                          <v-form
                            autocomplete="off"
                            lazy-validation
                            ref="form"
                            class="auth-form"
                          >
                            <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Название</div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  required
                                  disabled
                                ></v-text-field>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Город </div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Тип</div>
                                <v-select
                                  :items="['Нормальный тип', 'Мутный тип', 'Чёткий тип', 'Не тип']"
                                  outlined
                                  dense
                                  required
                                ></v-select>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Адрес</div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </div>
                            </div>

                            <div class="add-files">
                              <div class="input-label">Добавление файлов</div>
                              <div class="add-files--button">
                                <v-btn
                                  type="submit"
                                  color="primary"
                                  class="btn-blue mb-0 btn-small"
                                >
                                  <v-icon class="mr-2">mdi-account-circle-outline</v-icon>
                                  Добавить
                                </v-btn>
                                <div class="add-files--button-text">Минимум 4, максимум 15 изображений. Формат – JPG, PNG, TIFF или BMP. Размер – не более 5 МБ. Рекомендуемое разрешение – не менее 720 x 720 пикс. и не более 3000 x 3000 пикс.</div>
                              </div>
                              <div class="add-files--list">
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                              </div>
                            </div>

                            <div class="auth-form--wrap">
                              <div class="input-label">Описание</div>
                              <v-textarea
                                filled
                                outlined
                                dense
                              ></v-textarea>
                            </div>
                            <div class="auth-form--wrap with-chbox">
                              <div class="card-checkbox">
                                <v-checkbox v-model="checkbox" hide-details>
                                  <template v-slot:label>
                                    <div class="input-label">
                                      <span class="font-weight-black">Публичная работа</span>
                                      <span class="color-grey">Данная работа будет доступна для просмотра заказчикам</span>
                                    </div>
                                  </template>
                                </v-checkbox>
                              </div>
                              <v-btn
                                type="submit"
                                color="primary"
                                class="btn-blue mb-0"
                              >
                                Сохранить / Опубликовать
                              </v-btn>
                            </div>
                          </v-form>


                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </div>

                  <div class="portfolio--cards-point">
                    <div class="portfolio--cards-point-img">
                      <img src="../../../assets/images/portfolio-img03.jpg" alt="">
                    </div>
                    <div class="portfolio--cards-point-title">Тут все сделали пока мы ехали, на таможне 3 дня простояли</div>
                    <div class="portfolio--cards-point-location">
                      <img src="@/assets/images/ico-location.svg" alt="">
                      <span>Калининград</span>
                    </div>
                    <v-dialog
                      v-model="dialog4"
                      max-width="800px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="portfolio--cards-point-more"
                        >
                          Подробнее
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title class="card-title">
                          Добавление / изменение работы
                        </v-card-title>
                        <v-card-text>
                          <v-form
                            autocomplete="off"
                            lazy-validation
                            ref="form"
                            class="auth-form"
                          >
                            <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Название</div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  required
                                  disabled
                                ></v-text-field>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Город </div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Тип</div>
                                <v-select
                                  :items="['Нормальный тип', 'Мутный тип', 'Чёткий тип', 'Не тип']"
                                  outlined
                                  dense
                                  required
                                ></v-select>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Адрес</div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </div>
                            </div>

                            <div class="add-files">
                              <div class="input-label">Добавление файлов</div>
                              <div class="add-files--button">
                                <v-btn
                                  type="submit"
                                  color="primary"
                                  class="btn-blue mb-0 btn-small"
                                >
                                  <v-icon class="mr-2">mdi-account-circle-outline</v-icon>
                                  Добавить
                                </v-btn>
                                <div class="add-files--button-text">Минимум 4, максимум 15 изображений. Формат – JPG, PNG, TIFF или BMP. Размер – не более 5 МБ. Рекомендуемое разрешение – не менее 720 x 720 пикс. и не более 3000 x 3000 пикс.</div>
                              </div>
                              <div class="add-files--list">
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                              </div>
                            </div>

                            <div class="auth-form--wrap">
                              <div class="input-label">Описание</div>
                              <v-textarea
                                filled
                                outlined
                                dense
                              ></v-textarea>
                            </div>
                            <div class="auth-form--wrap with-chbox">
                              <div class="card-checkbox">
                                <v-checkbox v-model="checkbox" hide-details>
                                  <template v-slot:label>
                                    <div class="input-label">
                                      <span class="font-weight-black">Публичная работа</span>
                                      <span class="color-grey">Данная работа будет доступна для просмотра заказчикам</span>
                                    </div>
                                  </template>
                                </v-checkbox>
                              </div>
                              <v-btn
                                type="submit"
                                color="primary"
                                class="btn-blue mb-0"
                              >
                                Сохранить / Опубликовать
                              </v-btn>
                            </div>
                          </v-form>


                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </div>

                  <div class="portfolio--cards-point">
                    <div class="portfolio--cards-point-img">
                      <img src="../../../assets/images/portfolio-img04.jpg" alt="">
                    </div>
                    <div class="portfolio--cards-point-title">Тут вообще все просто</div>
                    <div class="portfolio--cards-point-location">
                      <img src="@/assets/images/ico-location.svg" alt="">
                      <span>Область такая что и название не выговоришь</span>
                    </div>
                    <v-dialog
                      v-model="dialog1"
                      max-width="800px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="portfolio--cards-point-more"
                        >
                          Подробнее
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title class="card-title">
                          Добавление / изменение работы
                        </v-card-title>
                        <v-card-text>
                          <v-form
                            autocomplete="off"
                            lazy-validation
                            ref="form"
                            class="auth-form"
                          >
                            <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Название</div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  required
                                  disabled
                                ></v-text-field>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Город </div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Тип</div>
                                <v-select
                                  :items="['Нормальный тип', 'Мутный тип', 'Чёткий тип', 'Не тип']"
                                  outlined
                                  dense
                                  required
                                ></v-select>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Адрес</div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </div>
                            </div>

                            <div class="add-files">
                              <div class="input-label">Добавление файлов</div>
                              <div class="add-files--button">
                                <v-btn
                                  type="submit"
                                  color="primary"
                                  class="btn-blue mb-0 btn-small"
                                >
                                  <v-icon class="mr-2">mdi-account-circle-outline</v-icon>
                                  Добавить
                                </v-btn>
                                <div class="add-files--button-text">Минимум 4, максимум 15 изображений. Формат – JPG, PNG, TIFF или BMP. Размер – не более 5 МБ. Рекомендуемое разрешение – не менее 720 x 720 пикс. и не более 3000 x 3000 пикс.</div>
                              </div>
                              <div class="add-files--list">
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                              </div>
                            </div>

                            <div class="auth-form--wrap">
                              <div class="input-label">Описание</div>
                              <v-textarea
                                filled
                                outlined
                                dense
                              ></v-textarea>
                            </div>
                            <div class="auth-form--wrap with-chbox">
                              <div class="card-checkbox">
                                <v-checkbox v-model="checkbox" hide-details>
                                  <template v-slot:label>
                                    <div class="input-label">
                                      <span class="font-weight-black">Публичная работа</span>
                                      <span class="color-grey">Данная работа будет доступна для просмотра заказчикам</span>
                                    </div>
                                  </template>
                                </v-checkbox>
                              </div>
                              <v-btn
                                type="submit"
                                color="primary"
                                class="btn-blue mb-0"
                              >
                                Сохранить / Опубликовать
                              </v-btn>
                            </div>
                          </v-form>


                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </div>

                  <div class="portfolio--cards-point">
                    <div class="portfolio--cards-point-img">
                      <img src="../../../assets/images/portfolio-img05.jpg" alt="">
                    </div>
                    <div class="portfolio--cards-point-title">А тут у нас отобрали инструменты и заставили все пределывать ногами</div>
                    <div class="portfolio--cards-point-location">
                      <img src="@/assets/images/ico-location.svg" alt="">
                      <span>Ростовская область</span>
                    </div>
                    <v-dialog
                      v-model="dialog5"
                      max-width="800px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="portfolio--cards-point-more"
                        >
                          Подробнее
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title class="card-title">
                          Добавление / изменение работы
                        </v-card-title>
                        <v-card-text>
                          <v-form
                            autocomplete="off"
                            lazy-validation
                            ref="form"
                            class="auth-form"
                          >
                            <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Название</div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  required
                                  disabled
                                ></v-text-field>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Город </div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Тип</div>
                                <v-select
                                  :items="['Нормальный тип', 'Мутный тип', 'Чёткий тип', 'Не тип']"
                                  outlined
                                  dense
                                  required
                                ></v-select>
                              </div>
                              <div class="auth-form--wrap-col w50">
                                <div class="input-label">Адрес</div>
                                <v-text-field
                                  type="text"
                                  autofocus
                                  outlined
                                  dense
                                  disabled
                                ></v-text-field>
                              </div>
                            </div>

                            <div class="add-files">
                              <div class="input-label">Добавление файлов</div>
                              <div class="add-files--button">
                                <v-btn
                                  type="submit"
                                  color="primary"
                                  class="btn-blue mb-0 btn-small"
                                >
                                  <v-icon class="mr-2">mdi-account-circle-outline</v-icon>
                                  Добавить
                                </v-btn>
                                <div class="add-files--button-text">Минимум 4, максимум 15 изображений. Формат – JPG, PNG, TIFF или BMP. Размер – не более 5 МБ. Рекомендуемое разрешение – не менее 720 x 720 пикс. и не более 3000 x 3000 пикс.</div>
                              </div>
                              <div class="add-files--list">
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                                <div class="auth-form--wrap add-photo">
                                  <v-file-input
                                    class="mt-0 pt-0"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-camera-plus-outline"
                                  ></v-file-input>
                                  <i class="ico-delete">
                                    <img src="@/assets/images/ico-delete.svg" alt="">
                                  </i>
                                </div>
                              </div>
                            </div>

                            <div class="auth-form--wrap">
                              <div class="input-label">Описание</div>
                              <v-textarea
                                filled
                                outlined
                                dense
                              ></v-textarea>
                            </div>
                            <div class="auth-form--wrap with-chbox">
                              <div class="card-checkbox">
                                <v-checkbox v-model="checkbox" hide-details>
                                  <template v-slot:label>
                                    <div class="input-label">
                                      <span class="font-weight-black">Публичная работа</span>
                                      <span class="color-grey">Данная работа будет доступна для просмотра заказчикам</span>
                                    </div>
                                  </template>
                                </v-checkbox>
                              </div>
                              <v-btn
                                type="submit"
                                color="primary"
                                class="btn-blue mb-0"
                              >
                                Сохранить / Опубликовать
                              </v-btn>
                            </div>
                          </v-form>


                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </div>


                </div>
              </div>
            </div>

            <div class="text-xs-center">
              <v-pagination
                v-model="page"
                :length="10"
                :total-visible="7"
              ></v-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'Page4',
  data() {
    return {
      menuItems: [
        { title: 'Главная', icon: 'mdi-home-outline' },
        { title: 'Портфолио', icon: 'mdi-image-multiple' },
        { title: 'Чат с менеджером', icon: 'mdi-forum-outline' },
        { title: 'Специализации', icon: 'mdi-folder-star-outline' },
        { title: 'Мои работы', icon: 'mdi-domain' },
        { title: 'Обучение (тесты)', icon: 'mdi-school-outline' },
        { title: 'Новости', icon: 'mdi-newspaper' },
        { title: 'Где купить', icon: 'mdi-shopping-outline' },
        { title: 'Расписание семинаров', icon: 'mdi-format-list-checkbox' },
        { title: 'Помощь', icon: 'mdi-help-circle-outline' },
        { title: 'Обращения', icon: 'mdi-relative-scale' },
        { title: 'ЧаВо', icon: 'mdi-frequently-asked-questions' },
        { title: 'Призы', icon: 'mdi-license' },
        { title: 'Мои монтажи', icon: 'mdi-android-studio' },
      ],
      navItems: [
        { title: 'Персональные данные', icon: 'mdi-account', class: 'active' },
        { title: 'Информация о компании', icon: 'mdi-information-variant' },
        { title: 'Изменение пароля', icon: 'mdi-lock-outline' },
      ],
      menuMob: null,
      small: false,
      smaller: false,
      searchShow: false,
      searchArea: false,
      submenuBtn: false,
      userAva: false,
      page: 1,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      checkbox: false,
    };
  },
  created() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.small = window.innerWidth <= 1024;
      this.userAva = window.innerWidth <= 1024;
      this.smaller = window.innerWidth <= 599;
      this.searchShow = window.innerWidth <= 599;
      // console.log(this.small ? this.menuMob : false);
    },
  },
};
</script>

<style lang="scss" src="./style.scss">

</style>
